export const ROW_SELECTED_NONE = 0;
export const ROW_SELECTED_SOME = 1;
export const ROW_SELECTED_ALL = 2;
export const ROW_ALL_IN_CART = 3;
